import {
    mdiLogout,
    mdiMessageQuestionOutline,
    mdiMessageTextOutline,
    mdiPlusCircleOutline,
} from '@mdi/js'
import {iconProfile} from '@shared/helpers/icons'
import {DropdownDivider} from 'swayok-react-mdb-ui-kit/components/Dropdown/DropdownDivider'
import {DropdownItem} from 'swayok-react-mdb-ui-kit/components/Dropdown/DropdownItem'
import {DropdownText} from 'swayok-react-mdb-ui-kit/components/Dropdown/DropdownText'
import {Icon} from 'swayok-react-mdb-ui-kit/components/Icon/Icon'
import {IconButton} from 'swayok-react-mdb-ui-kit/components/Icon/IconButton'
import {NavigationService} from 'swayok-react-mdb-ui-kit/services/NavigationService'
import {AppConfig} from '../../../AppConfig'
import {appUrl} from '../../../AppUrl'
import {Blinker} from '../../../components/Blinker'
import {trans} from '../../../helpers'
import {useUserData} from '../../../hooks'
import {
    useAccountFlagsStore,
    useAuthStore,
    useTopMenuStore,
} from '../../../stores'
import {TopNavigationCreateAdButton} from './TopNavigationCreateAdButton'

interface TopNavigationUserDropdownMenuLinksProps {
    forMobile?: boolean
}

export function TopNavigationUserDropdownMenuLinks(props: TopNavigationUserDropdownMenuLinksProps) {

    const {
        forMobile = false,
    } = props

    const user = useUserData()
    const hasNewChatMessages = useAccountFlagsStore(
        state => state.hasNewChatMessages
    )
    const hasNewSupportTicketReplies = useAccountFlagsStore(
        state => state.hasNewSupportTicketReplies
    )
    const logout = useAuthStore(
        state => state.logout
    )
    const createAdButton = useTopMenuStore(
        state => state.createAdButton
    )

    return (
        <>
            {forMobile && (
                <DropdownItem
                    href={appUrl().about}
                >
                    {trans().common.top_navigation.about_project}
                </DropdownItem>
            )}
            <DropdownItem
                href={appUrl().support.rulesAndDocuments}
            >
                {trans().common.top_navigation.rules}
            </DropdownItem>
            {AppConfig.features.news !== false && (
                <DropdownItem
                    href={appUrl().news.list}
                >
                    {trans().common.top_navigation.news}
                </DropdownItem>
            )}
            <DropdownItem
                href={appUrl().support.index}
            >
                {trans().common.top_navigation.support}
            </DropdownItem>

            <DropdownDivider />
            {forMobile && createAdButton && (
                <DropdownText>
                    <TopNavigationCreateAdButton forDropdownMenu={true} />
                </DropdownText>
            )}
            <DropdownItem
                href={appUrl().cabinet.ads.index}
                className="with-blinker"
            >
                {trans().cabinet.side_navigation.my_ads}
                {!forMobile && createAdButton && (
                    <IconButton
                        path={mdiPlusCircleOutline}
                        color="green"
                        href={appUrl().cabinet.ads.create}
                    />
                )}
            </DropdownItem>
            <DropdownItem
                href={appUrl().cabinet.executors.index}
            >
                {trans().cabinet.side_navigation.my_services}
            </DropdownItem>
            <DropdownItem
                href={appUrl().cabinet.reviews}
            >
                {trans().cabinet.side_navigation.my_reviews}
            </DropdownItem>
            <DropdownItem
                href={appUrl().cabinet.favorites}
            >
                {trans().cabinet.side_navigation.my_favorites}
            </DropdownItem>
            <DropdownItem
                href={appUrl().cabinet.subscriptions}
            >
                {trans().cabinet.side_navigation.my_subscriptions}
            </DropdownItem>

            <DropdownDivider />

            <DropdownItem
                href={appUrl().cabinet.chats.index}
                className="with-blinker"
            >
                {trans().cabinet.side_navigation.my_chats}
                {hasNewChatMessages && (
                    <Blinker repeats={3}>
                        <Icon
                            path={mdiMessageTextOutline}
                            tooltip={trans().cabinet.side_navigation.has_new_chat_messages}
                            size={20}
                            color="blue"
                        />
                    </Blinker>
                )}
            </DropdownItem>
            <DropdownItem
                href={appUrl().cabinet.notifications.index}
            >
                {trans().cabinet.side_navigation.notifications}
            </DropdownItem>
            <DropdownItem
                href={appUrl().cabinet.supportTickets.index}
                className="with-blinker"
            >
                {trans().cabinet.side_navigation.support_tickets}
                {hasNewSupportTicketReplies && (
                    <Blinker repeats={3}>
                        <Icon
                            path={mdiMessageQuestionOutline}
                            tooltip={trans().cabinet.side_navigation.has_new_support_ticket_replies}
                            size={20}
                            color="orange"
                        />
                    </Blinker>
                )}
            </DropdownItem>

            {user && (
                <>
                    <DropdownDivider />

                    <DropdownItem
                        href={NavigationService.makeUrl(
                            appUrl().cabinet.advancePayments.surveyForm,
                            null,
                            {step: '1'}
                        )}
                    >
                        {trans().cabinet.side_navigation.client_data}
                    </DropdownItem>
                    <DropdownItem
                        href={appUrl().cabinet.advancePayments.contract}
                    >
                        {trans().cabinet.side_navigation.active_contract}
                    </DropdownItem>
                    <DropdownItem
                        href={appUrl().cabinet.transactions.index}
                    >
                        {trans().cabinet.side_navigation.transactions}
                    </DropdownItem>
                </>
            )}
            {user && (
                <>
                    <DropdownDivider />

                    <DropdownItem
                        href={appUrl().cabinet.settings.index}
                        className="with-icon-flex gap-2"
                    >
                        <Icon
                            path={iconProfile}
                        />
                        {trans().cabinet.side_navigation.settings}
                    </DropdownItem>

                    <DropdownItem
                        href={appUrl().logout}
                        className="with-icon-flex gap-2"
                        onClick={e => {
                            e.preventDefault()
                            logout()
                        }}
                    >
                        <Icon
                            path={mdiLogout}
                        />
                        {trans().cabinet.side_navigation.logout}
                    </DropdownItem>
                </>
            )}
        </>
    )
}
